<template lang="pug" src="./form.pug"></template>

<script>
import api from 'api'
import axios from 'axios'
export default {
  data: () => {
    return {
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      newPatient: '',
      message: '',
      postUrl: api + '/rg-mail/v1/contact',
      formSubmitted: false,
      formSuccess: false,
      active: ''
    }
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  methods: {
    acceptNumber () {
      var x = this.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
      this.phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
    },
    validate () {
      this.$validator.validateAll()
        .then(res => {
          if (res) {
            this.onSubmit()
          }
        })
        .catch(e => { console.log(e) })
    },
    onSubmit () {
      this.formSubmitted = true
      axios.post(this.postUrl, {
        firstName: this.firstName,
        lastName: this.lastName,
        phone: this.phone,
        email: this.email,
        newPatient: this.newPatient,
        message: this.message
      })
        .then(res => {
          this.active = ''
          this.clearForm()
          this.formSuccess = true
          setTimeout(() => { this.form.reset() }, 50)
        })
        .catch(e => { console.log(e) })
    },
    clearForm () {
      this.firstName = ''
      this.lastName = ''
      this.email = ''
      this.phone = ''
      this.newPatient = ''
      this.message = ''
    },
    focused (name) {
      this.active = name
    },
    handleClose () {
      this.formSubmitted = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/form.vue